import { ecsApi } from '@services';
import {
    CreateEpiOrderPayload,
    CreateEpiOrderResponse,
    DeleteEpiOrderPayload,
    DeleteEpiOrderResponse,
    GetEpiOrdersResponse,
    UpdateEpiOrderPayload,
    UpdateEpiOrderResponse
} from './epiOrders.types';

export const epiOrdersApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        getEpiOrders: builder.mutation<GetEpiOrdersResponse, void>({
            query: () => ({
                url: '/orders-epi',
                method: 'GET'
            })
        }),
        createEpiOrder: builder.mutation<CreateEpiOrderResponse, CreateEpiOrderPayload>({
            query: (payload) => ({
                url: '/orders-epi',
                method: 'POST',
                body: payload
            })
        }),
        updateEpiOrder: builder.mutation<UpdateEpiOrderResponse, UpdateEpiOrderPayload>({
            query: (payload) => ({
                url: '/orders-epi',
                method: 'PUT',
                body: payload
            })
        }),
        deleteEpiOrder: builder.mutation<DeleteEpiOrderResponse, DeleteEpiOrderPayload>({
            query: (payload) => ({
                url: '/orders-epi',
                method: 'DELETE',
                body: payload
            })
        })
    })
});

export const { useGetEpiOrdersMutation, useCreateEpiOrderMutation, useUpdateEpiOrderMutation, useDeleteEpiOrderMutation } = epiOrdersApi;
